import React from "react";
import { Grid } from "@mui/material";

import SourceDetailsTableFilter from "../source-details-table/source-details-table-filter";
import SourceDetailsTable from "../source-details-table/source-details-table";
import SourceSummary from "../summary-section/source-summary";
import EntityTableFilter from "../entity-table/entity-table-filter";
import { TableData } from "../entity-table/utils";
import EntityTable from "../entity-table/entity-table";
import EntitySummary from "../summary-section/entity-summary";
import { Entity, Source } from "../../pii.types";

interface SourceDetailsProps {
    activeEntity: Entity;
    activeSource: Source;
    tableData: TableData[];
    filteredTableData: TableData[];
    setFilteredTableData: React.Dispatch<React.SetStateAction<TableData[]>>;
    setActiveEntity: (value: any) => void;
    sensitiveDataIdentifiers: { label: string; value: string }[];
}

const SourceDetails = ({
    tableData,
    filteredTableData,
    setFilteredTableData,
    sensitiveDataIdentifiers,
    activeSource,
    activeEntity,
    setActiveEntity
}: SourceDetailsProps) => {
    return (
        <Grid display={"flex"} gap={3} px={4} py={3} width={"100%"} height={"calc(100% - 83px)"}>
            <Grid display={"flex"} flexDirection={"column"} item gap={!activeEntity ? 2 : 0} flex={1}>
                {activeEntity ? (
                    <>
                        <EntityTableFilter
                            entityName={activeEntity.type}
                            fieldType={activeEntity.fieldType}
                            tableData={tableData}
                            filteredTableData={filteredTableData}
                            setFilteredTableData={setFilteredTableData}
                            sensitiveDataIdentifiers={sensitiveDataIdentifiers}
                        />
                        <EntityTable
                            eventType={activeEntity.eventType}
                            fieldType={activeEntity.fieldType}
                            tableData={filteredTableData}
                        />
                    </>
                ) : (
                    <>
                        <SourceDetailsTableFilter
                            entityName={activeSource.type}
                            tableData={tableData}
                            setFilteredTableData={setFilteredTableData}
                            sensitiveDataIdentifiers={sensitiveDataIdentifiers}
                        />
                        <SourceDetailsTable
                            entityName={activeSource.type}
                            eventType={activeSource.eventType}
                            fieldType={activeSource.fieldType}
                            tableData={filteredTableData}
                            onClick={setActiveEntity}
                        />
                    </>
                )}
            </Grid>
            {activeEntity ? (
                <EntitySummary
                    sensitiveColumns={activeEntity.columnsWithSensitiveData}
                    totalColumns={activeEntity.totalColumns}
                    rowsSampled={activeEntity.rowsSampled}
                    identifiers={activeEntity.sensitiveDataIdentifiers}
                    eventType={activeEntity.eventType}
                    fieldType={activeEntity.fieldType}
                />
            ) : (
                <SourceSummary activeSource={activeSource} />
            )}
        </Grid>
    );
};

export default SourceDetails;
